var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"copyright"}},[_c('p',[_vm._v("By using this service, you agree to abide by CSUB policies, data restrictions, and applicable laws."),_c('br'),_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright - California State University Bakersfield")])])
}
var staticRenderFns = []

export { render, staticRenderFns }